module.exports = __webpack_public_path__ + "static/media/fraz_profile.2528e298.png";